import { createContext } from "react";
const DigitFormContext = createContext({});
export default DigitFormContext;
